import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export const BenefitsSection: React.FC = () => {
  const {
    t
  } = useLanguage();
  const benefits = [{
    image: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=160&h=160&fit=crop&q=80',
    title: t('benefits.1.title'),
    desc: t('benefits.1.desc')
  }, {
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=160&h=160&fit=crop&q=80',
    title: t('benefits.2.title'),
    desc: t('benefits.2.desc')
  }, {
    image: 'https://images.unsplash.com/photo-1598550476439-6847785fcea6?w=160&h=160&fit=crop&q=80',
    title: t('benefits.3.title'),
    desc: t('benefits.3.desc')
  }];
  return <section className="py-24 bg-beige-50 border-y border-beige-100" data-id="element-11">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-12">
        <div className="grid md:grid-cols-3 gap-12" data-id="element-13">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="text-center" data-id="element-14">
              <div className="w-20 h-20 mx-auto rounded-2xl shadow-sm border border-beige-200 overflow-hidden mb-6 transform rotate-3 hover:rotate-0 transition-transform duration-300" data-id="element-15">
                <img src={benefit.image} alt={benefit.title} className="w-full h-full object-cover" data-id="element-16" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-dark" data-id="element-17">
                {benefit.title}
              </h3>
              <p className="text-gray-600 font-sans leading-relaxed" data-id="element-18">
                {benefit.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};